import clsx from "clsx";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../../app/modules/auth";
import { MenuComponent } from "../../../assets/ts/components";
import { KTIcon } from "../../../helpers";

const API_URL = import.meta.env.VITE_APP_API_URL;

type Props = {
	toggleBtnClass?: string;
	toggleBtnIconClass?: string;
	menuPlacement?: string;
	menuTrigger?: string;
};

const AuthUserHeader = ({
	toggleBtnClass = "",
	menuPlacement = "bottom-end",
	menuTrigger = "{default: 'click', lg: 'hover'}",
}: Props) => {
	const { currentUser, logout } = useAuth();

	useEffect(() => {
		setTimeout(() => {
			MenuComponent?.reinitialization();
		}, 300);
	}, []);

	const getImageUrl = (path: string | undefined) => {
		if (!path) return "";
		if (path.startsWith("http") || path.startsWith("data:")) return path;
		return `${API_URL}/${path}`;
	};

	return (
		<>
			{/* begin::Menu toggle (DESKTOP) */}
			<button
				type="button"
				className={clsx("btn btn-link p-0 d-none d-lg-flex", toggleBtnClass)}
				data-kt-menu-trigger={menuTrigger}
				data-kt-menu-attach="parent"
				data-kt-menu-placement={menuPlacement}
				style={{ zIndex: 999999, position: "relative" }}
			>
				{/*begin::User*/}
				<div className="aside-user d-flex align-items-center">
					{/*begin::Symbol*/}
					<div className="symbol symbol-50px">
						{currentUser?.profile_picture ? (
							<img
								src={getImageUrl(currentUser.profile_picture)}
								alt="User avatar"
							/>
						) : currentUser?.avatar ? (
							<img src={getImageUrl(currentUser.avatar)} alt="User avatar" />
						) : (
							<div
								className="symbol-label fs-0 fw-bold text-primary bg-light-primary"
								style={{ fontSize: "2rem" }}
							>
								{currentUser?.name?.charAt(0)?.toUpperCase() ||
									currentUser?.username?.charAt(0)?.toUpperCase()}
							</div>
						)}
					</div>
					{/*end::Symbol*/}

					{/*begin::Wrapper*/}
					<div className="aside-user-info flex-row-fluid flex-wrap ms-5">
						{/*begin::Section*/}
						<div className="d-flex my-1">
							{/*begin::Info*/}
							<div className="flex-grow-1 me-2 text-start">
								{/*begin::Role*/}
								<span className="text-gray-800 text-hover-primary fs-5 fw-bold d-block">
									{currentUser?.role_id === 5
										? "Customer"
										: currentUser?.role || "User"}
								</span>
								{/*end::Role*/}

								{/*begin::Username*/}
								<span className="text-gray-600 fw-bold d-block fs-7">
									{currentUser?.user_name || currentUser?.name || ""}
								</span>
								{/*end::Username*/}
							</div>
							{/*end::Info*/}
						</div>
						{/*end::Section*/}
					</div>
					{/*end::Wrapper*/}
				</div>
				{/*end::User*/}
			</button>
			{/* end::Menu toggle */}

			{/* begin::Menu */}
			<div
				className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold w-175px"
				data-kt-menu="true"
			>
				<div className="menu-item">
					<Link
						to="/change-password"
						title="Change Password"
						className="menu-link"
					>
						<KTIcon iconName="lock" className="fs-1 me-2" /> Change Password
					</Link>
				</div>
				<div className="menu-item ">
					<a onClick={logout} className="menu-link " role="button" tabIndex={0}>
						<KTIcon iconName="arrow-right" className="fs-1 me-2" /> Sign Out
					</a>
				</div>
			</div>
			{/* end::Menu */}

			{/* begin::Mobile Native Dropdown (MOBILE ONLY) */}
			<div className="d-flex d-lg-none align-items-center dropdown">
				<div
					className="d-flex align-items-center cursor-pointer"
					data-bs-toggle="dropdown"
					aria-expanded="false"
				>
					<div className="symbol symbol-40px">
						{currentUser?.profile_picture ? (
							<img
								src={getImageUrl(currentUser.profile_picture)}
								alt="User avatar"
							/>
						) : currentUser?.avatar ? (
							<img src={getImageUrl(currentUser.avatar)} alt="User avatar" />
						) : (
							<div className="symbol-label fs-4 fw-bold text-primary bg-light-primary shadow-sm border">
								{currentUser?.name?.charAt(0)?.toUpperCase() ||
									currentUser?.username?.charAt(0)?.toUpperCase()}
							</div>
						)}
					</div>
					<div className="ms-3 text-start mt-1">
						<span className="text-gray-800 text-hover-primary fs-6 fw-bold d-block lh-1">
							{currentUser?.role_id === 5
								? "Customer"
								: currentUser?.role || "User"}
						</span>
						<span className="text-gray-600 fw-bold d-block fs-8 mt-1">
							{currentUser?.user_name || currentUser?.name || ""}
						</span>
					</div>
				</div>
				<ul className="dropdown-menu dropdown-menu-end py-4 fs-6 w-175px shadow border-0 mt-2">
					<li>
						<Link
							to="/change-password"
							className="dropdown-item px-5 fw-bold text-gray-800 text-hover-primary d-flex align-items-center"
						>
							<KTIcon iconName="lock" className="fs-2 me-2" /> Change Password
						</Link>
					</li>
					<li>
						<a
							onClick={logout}
							className="dropdown-item px-5 fw-bold text-gray-800 text-hover-primary d-flex align-items-center"
							role="button"
							tabIndex={0}
						>
							<KTIcon iconName="arrow-right" className="fs-2 me-2" /> Sign Out
						</a>
					</li>
				</ul>
			</div>
			{/* end::Mobile Native Dropdown */}
		</>
	);
};

export { AuthUserHeader };
